import styled, { css } from "styled-components";
import { colors } from "@a0/quantum-web";

export const Header = styled.header`
  background: ${({ dark }) =>
    dark ? colors.neutral_n900 : colors.neutral_n800};
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  z-index: 1000;
  overflow: auto;
  max-width: 144rem;
  transition: all 0.4s ease;

  ${({ dark }) =>
    !dark &&
    `
    border-bottom: 0.1rem solid rgba(255, 255, 255, 0.2);
  `}

  ${({ isMobileMenuOpen }) =>
    isMobileMenuOpen &&
    `
    height: 100%;
  `}

  ${({ theme }) => theme.quantum.media.tablet`
    overflow: visible;
  `}

  ${({ theme, hasScrolled }) =>
    hasScrolled &&
    theme.quantum.media.tablet`
    border-radius: 0 0 1.6rem 1.6rem;
    border-bottom: none;
  `}
`;

export const ObservedPixel = styled.div`
  height: 0.1rem;
  position: absolute;
  visibility: hidden;
  top: 0;
`;

export const TopBanner = styled.div`
  background: linear-gradient(90deg, #ff4f40 0%, #f4d 99.99%);
  width: 100%;
  padding: 0.8rem 1.6rem;
  border-bottom: 0.1rem solid rgba(255, 255, 255, 0.1);
  visibility: visible;
  opacity: 1;
  height: 6rem;
  overflow: hidden;
  transition: all 0.4s linear;

  ${({ hide }) =>
    hide &&
    css`
      visibility: hidden;
      height: 0;
      opacity: 0;
      padding: 0;
      transition: all 0.4s linear;
    `}

  ${({ theme, hide }) => theme.quantum.media.tablet`
    height: ${hide ? "0" : "4.8rem"};
    padding: ${hide ? "0" : "1.2rem 2.4rem"};
  `}
`;

export const TopBannerContainer = styled.div`
  max-width: 121.6rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 3rem;
  align-items: center;
  height: 100%;

  div p {
    display: inline;
    margin-right: 2rem;
  }
`;

export const CloseButton = styled.button`
  transform: rotate(45deg);
  background: none;
  color: ${colors.neutral_white};
  border: none;
  font-size: 2rem;
  justify-self: flex-end;
  font-weight: 500;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;

export const Spacer = styled.div`
  visibility: visible;
  opacity: 1;
  height: 4.8rem;
  ${({ hide }) =>
    hide &&
    css`
      visibility: hidden;
      height: 0;
      opacity: 0;
      padding: 0;
      transition: all 0.4s linear;
    `}
`;
